import { render } from "./SideNaveMobiPainel.vue?vue&type=template&id=52b67fda&scoped=true"
import script from "./SideNaveMobiPainel.vue?vue&type=script&lang=js"
export * from "./SideNaveMobiPainel.vue?vue&type=script&lang=js"

import "./SideNaveMobiPainel.vue?vue&type=style&index=0&id=52b67fda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b67fda"]])

export default __exports__